import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useNavigation } from '../hooks/useNavigation';
import { useAuth } from '../hooks/useAuth';
import { pathWithEmpresa } from '../utils/companyUrl';

/**
 * Componente para proteger rutas basado en roles
 */
const ProtectedRoute = ({ children }) => {
  const { canAccessRoute, getDefaultRoute } = useNavigation();
  const { selectedCompany, empresaIdFromUrl } = useAuth();
  const location = useLocation();

  const hasAccess = canAccessRoute(location.pathname);

  if (!hasAccess) {
    return <Navigate to={pathWithEmpresa(getDefaultRoute, empresaIdFromUrl || selectedCompany?.id)} replace />;
  }

  return children;
};

export default ProtectedRoute;
